'use strict';

var filterModelMixin = require('../filters/utils/filter.model.mixin');
var PricePerTimeIntervalModel = Odigeo.Model.extend({
    idAttribute: 'interval',
});
var PricePerTimeIntervalCollection = Odigeo.Collection.extend({
    model: PricePerTimeIntervalModel,
});

module.exports = Backbone.Model.extend(Odigeo._.defaults({
    initModel: function(metadata) {
        var pricePerTimeIntervalCollection = Odigeo._.map(metadata.pricesPerHour, function(pricePerInterval, hour) {
            return {
                interval: hour,
                price: pricePerInterval,
            };
        });
        this.set({
            pricePerTimeIntervalCollection: new PricePerTimeIntervalCollection(pricePerTimeIntervalCollection),
            eightyPercentilePrice: metadata.eightyPercentilePrice,
            minSelectedHour: 0,
            maxSelectedHour: 24,
        }, {silent: true});
    },
}, filterModelMixin));
